import { create } from 'zustand';

export interface AiMessage {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  data_table?: {
    headers: string[];
    rows: string[][];
  };
  references?: Array<{
    type: string;
    id: string;
    label: string;
  }>;
  sources_queried?: string[];
  timestamp: string;
}

interface AiAssistantState {
  isPanelOpen: boolean;
  messages: AiMessage[];
  isLoading: boolean;

  setPanelOpen: (open: boolean) => void;
  togglePanel: () => void;
  addMessage: (message: AiMessage) => void;
  setLoading: (loading: boolean) => void;
  clearMessages: () => void;
  clearAllState: () => void;
}

export const useAiAssistantStore = create<AiAssistantState>()((set) => ({
  isPanelOpen: false,
  messages: [],
  isLoading: false,

  setPanelOpen: (open) => set({ isPanelOpen: open }),
  togglePanel: () => set((state) => ({ isPanelOpen: !state.isPanelOpen })),
  addMessage: (message) =>
    set((state) => ({ messages: [...state.messages, message].slice(-200) })),
  setLoading: (loading) => set({ isLoading: loading }),
  clearMessages: () => set({ messages: [] }),
  clearAllState: () => set({ isPanelOpen: false, messages: [], isLoading: false }),
}));
